<template>
    <div class="ratePage" v-wechat-title="this.title">
        <div class="rateMassage">
            <!-- <div class="img">
                <img :src="imgUrl" alt="">
            </div>
            <div class="word">
                <p class="title">
                    {{radioName}}-{{name}}
                </p>
                <p class="describe">
                    {{information}}
                </p>
                <div class="ratePeople">
                    <p class="setBorder">
                        总播放：{{show_spectators | show_spectator  }}
                        <span v-if="show_spectators.length>5">w</span>
                    </p>
                    <p class="border">

                    </p>
                    <p class="setPadding">
                        粉丝数：{{fans | show_spectator}}
                        <span v-if="fans.length>5">w</span>
                    </p>
                </div>
            </div> -->
            <div class="channelName">
                <p>
                    {{channelName}}
                </p>
                <img src="../../assets/bottom.png" alt=""  v-show="isInfo=='2'" style="cursor:pointer;display:inline-block;"  @click="showInfo">
                <img src="../../assets/top.png" alt=""  v-show="isInfo=='1'" style="cursor:pointer;display:inline-block;"  @click="hideInfo">
            </div>
            <div class="channelInfo" v-if="isInfo=='1'">
               <p>{{channelInfo}}</p>
            </div>
            <div class="boldLine"></div>

            <div class="downloadApp" @click="toDownloadpage">
                <p>
                    <img src="../../assets/downNew.png" alt="">
                </p>
            </div>


        </div>
        <!-- <spliteBold></spliteBold> -->

       
        <div class="content">
            <!-- <div class="oneProgram" v-for="onePregrme in data" :key="onePregrme.number" @click="nextPage(onePregrme.number,onePregrme.live_type,onePregrme.period)">
                <div class="img">
                    <img :src="onePregrme.image" alt="">
                </div>
                <div class="contents">
                    <p class="topic">{{onePregrme.title}}</p>
                    <p class="titles">{{onePregrme.show}}</p>
                    
                </div>
            </div> -->
            <ul class="when">
                <li v-for="(tab,index) in tabs" :class="{active:iscur==index}"   :key="index"  @click="iscur=index,tabChange(index)">
                {{tab.name}}
                </li>
            </ul>
         
            <programcommenNewC  :commenChannel='recommendRecorded'></programcommenNewC>
           
            
        </div>
        <myfooter></myfooter>
        <toast :msg="msg" ></toast>
    </div>
</template>
<script>
    // import programcommen from '../commen/programcommen'
    // import myfooter from '../commen/myfooter'
    // import hotRecommendMiddle from '../commen/hotRecommendMiddle'
    // let connection = navigator.connection||navigator.mozConnection||navigator.webkitConnection||{tyep:'unknown'};
    // let type_text = ['unknown','ethernet','wifi','2g','3g','4g','none'];
    import cbct from '../../../static/js/base.js'
    import toast from '../commen/toast.vue'
    import  myfooter from '../commen/myfooter'
    // import  spliteBold from '../commen/spliteBold'
    import share from '../../../static/js/share.js';
    import programcommenNewC from '../commen/programcommenNewC'
    import qs from 'qs'
    export default {
        name: 'ratePage',
        props: {
            
        },
        data(){
            return { 
                msg:'', 
                channel_id:'',
                data:[],
                info:{},
                title:'',
                radioName:'',
                information:'',
                name:'',
                show_spectators:'',
                fans:'',
                imgUrl:'',
                radio_name:'',
                channelName:'',
                channelInfo:'',
                today:[],
                tomorrow:[],
                yesterday:[],
                isInfo:'2',
                tabs:[{name:'昨天'},{name:'今天'},{name:'明天'}],
                iscur:1,
                recommendRecorded:[],

            }
        },
        filters:{
            show_spectator:function(num){
                if(num!=""){
                    let strNum="";
                if(num.length>=5){
                    strNum=parseFloat(parseFloat(num/10000).toFixed(1))
                }else{
                    strNum=num;
                }
                    return strNum; 
                } 
            }
        },
        created(){
            let self = this;
            if(self.$route.query.channel_id){
                self.channel_id=self.$route.query.channel_id;
            }else{
                // self.bus.$emit('toast',{show:true,title:'参数错误'})
            }
            this.getData();
        },
        methods:{
            showInfo:function(){
                this.isInfo='1';

            },
            hideInfo:function(){
               this.isInfo='2';
            },
            tabChange:function(tab){  //切换昨今明
                if (tab=='0') {
                   this.recommendRecorded=this.yesterday; 
                }else if(tab=='1'){
                   this.recommendRecorded=this.today; 

                }else if(tab=='2'){
                   this.recommendRecorded=this.tomorrow;                     
                }
            },

            getData:function(){
                var self = this;
                self.$api.get(cbct.baseurl+'share/channel-page?channel_id='+this.channel_id, qs.stringify({
                })).then((response)=>{
                    if(response.c == cbct.code.successCode){  
                        if(response.d.info.is_del=='1'){
                            console.log(response.d.info.is_del)
                            self.$router.push({
                                path:'delPage'
                            })
                            return;
                        }
                        // self.name = response.d.info.name; 
                        // self.information = response.d.info.information; 
                        // self.radioName = response.d.info.radio_name;
                        self.title = response.d.info.radio_name+'-'+response.d.info.name+'-听见广播'; 
                        // self.show_spectators = response.d.info.show_spectators;
                        // self.fans = response.d.info.fans;
                        // self.imgUrl = cbct.imgUrl()+response.d.info.img;
                        // self.data = response.d.live;
                        // for(var i=0;i<self.data.length;i++){
                        //     self.data[i].image = cbct.imgUrl()+self.data[i].image;
                        // }
                        share.share(this,window.location.href,response.d.info.name,'聚合热点信息，纵览精彩内容',cbct.imgUrl()+response.d.info.img,response.d.info.name);
                        share.QQshare(window.location.href,response.d.info.name,'聚合热点信息，纵览精彩内容',cbct.imgUrl()+response.d.info.img);
                        self.channelName=response.d.info.name;
                        self.channelInfo=response.d.info.information;
                        self.today=response.d.today;
                        self.tomorrow=response.d.tomorrow;
                        self.yesterday=response.d.yesterday;
                        self.recommendRecorded=response.d.today;
                    }else if(response.c == cbct.code.noLogin){
                    
                    }else if(response.c == cbct.code.raleNoLogin){
                                   
                    }else{
                        
                    }                    
                }
                ).catch((error)=>{console.log(error);})	  
            },
            nextPage:function(id,isLive,period){
                if(isLive=='1'){
                    this.$router.push({
                        path:'programRecorded?type=1&number='+id+'&isLive='+isLive+'&havebottom=1'+'&title='+this.title
                    })
                }else if(isLive == '2'){
                    this.$router.push({
                        path:'programRecorded?type=1&number='+id+'&isLive=0'+'&havebottom=1'+'&title='+this.title
                    })
                }else if(isLive == '3'){
                    this.bus.$emit('toast',{show:true,title:'抱歉~该节目当前不在播出时段，请留意官方信息。'})
                }
            },
            toDownloadpage(){//点击下载
                this.$router.push({path:"downloadApp?isFrom=programRecorded"});
            },
            

        },
        components: {
            // spliteBold,
            myfooter,
            toast,
            programcommenNewC
        }
        
    }
</script>
<style scoped lang="scss">
    .ratePage{
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        .rateMassage{
            margin: auto;
            // padding: 0 0.56rem;
            .channelName{
                box-sizing: border-box;
                padding: 0.56rem 0 0.32rem;
                font-size: 0.32rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 600;
                color: rgba(49, 49, 49, 1);
                img{
                    width: 0.22rem;
                    height: 0.22rem;
                    margin-left: 0.16rem;
                }
            }
            .channelInfo{
                font-size: 0.24rem;
                font-weight: 500;
                color: rgba(102, 102, 102, 1);
                padding: 0 0.31rem;
                padding-bottom: 0.23rem;
                text-align: left;
                line-height: 1.3;
                // padding: 0rem 0 0.23rem;
            }
            .boldLine{
                height: 0.2rem;
                background: rgba(248, 248, 248, 1);
            }
            
        }
        .content{
            .when{
                display: flex;
                align-items: center;
                box-sizing: border-box;
                border-bottom: solid 0.01rem rgba(221, 221, 221, 1);
                justify-content: space-around; 
                margin-bottom: 0.16rem;         
                li{
                    text-align: center;
                    font-size:0.3rem;
                    font-weight:500;
                    padding: 0.18rem 0;
                    color: rgba(102, 102, 102, 1);  
                }


                li.active{
                    color: rgba(204, 50, 50, 1) ;
                    border-bottom:  solid 0.04rem rgba(204, 50, 50, 1);
                    padding: 0.14rem 0;
                    font-size: 0.36rem;
                }

            }
        }


        // .rateMassage{
        //     width: 100%;
        //     height: auto;
        //     display: flex;
        //     flex-wrap:nowrap;
        //     justify-content:flex-start;
        //     background-image: url('../../assets/headerBack.png');
        //     background-size:100% 100%;
        //     .img{
        //         margin: 0.42rem 0.24rem 0.42rem 0.24rem;
        //         width: 1.68rem;
        //         flex:0 0 1.88rem;
        //         height: 1.88rem;
        //         box-sizing: border-box;
        //         img{
        //             width: 100%;
        //             display: block;
        //             height: 100%;
        //             border-radius: 0.1rem;
        //             box-shadow: #999999;
        //         }
        //     }
        //     .word{
        //         color: #fff;
        //         margin: 0 0.36rem 0 0;
        //         height: auto;
        //         text-align: left;
        //         .title{
        //             padding-top: 0.52rem;
        //             padding-bottom: 0.29rem;
        //             width: 4.78rem;
        //             font-size: 0.30rem;
        //             font-weight: bold;
        //             overflow: hidden;
        //             text-overflow: ellipsis;
        //             white-space: nowrap;
        //         }
        //         .describe{
        //             font-size: 0.24rem;  
        //             line-height: 0.35rem;
        //             width: 4.78rem;
        //             overflow:hidden;
        //             word-wrap:break-word;
        //             text-overflow:ellipsis;
        //             display:-webkit-box;
        //             /* autoprefixer: off */
        //             -webkit-box-orient:vertical;
        //             /* autoprefixer: on */
        //             -webkit-line-clamp:3;
        //         }
                
        //     }
        // }
        // .content{
        //     margin: 0.3rem 0.23rem;
        //     // cursor: pointer;
        //     display: flex;
        //     justify-content: space-between;
        //     flex-wrap: wrap;
        //     .oneProgram{
        //         width: 100%;
        //         display: flex;
        //         justify-content: space-between;
        //         margin-top: 0.28rem;
        //         .img{
        //             flex: 0 0 1.68rem;
        //             width: 1.68rem;
        //             height:1.68rem;;
                    
        //             img{
        //                 float: left;
        //                 width: 1.68rem;
        //                 height: 1.68rem;
        //                 // margin: 0.03rem;
        //                 border-radius: 0.1rem;
        //                 box-shadow: 0.06rem 0.06rem 0.06rem rgba(204, 204, 204, 0.5), 0.06rem -0.06rem 0.06rem rgba(204, 204, 204, 0.5), -0.06rem 0.06rem 0.06rem rgba(204, 204, 204, 0.5), -0.06rem -0.06rem 0.06rem rgba(204, 204, 204, 0.5);
        //             }
        //         }
        //         .contents{
        //             box-sizing: border-box;
        //             margin-left: 0.2rem;
        //             flex: 0 0 5.34rem;
        //             font-size: 0.13rem;
        //             border-bottom: 1px solid #DDDDDD;
        //             padding-bottom: 0.68rem;
        //             // margin-bottom: 0.28rem;
        //             p{
        //                 text-align: left;
        //                 width: 5.20rem;
        //                 font-size: 0.32rem;
        //                 overflow: hidden;
        //                 text-overflow: ellipsis;
        //                 white-space: nowrap;
        //             }
        //             .topic{
        //                 padding-top: 0.5rem;
        //                 color: #333333;
        //             }
        //             .titles{
        //                 padding-top: 0.15rem;
        //                 font-size: 0.26rem;
        //                 color: #999999;
        //             }
        //         }
        //     }
        // }
        .downloadApp{
            box-sizing: border-box;
            
         p{
            height: 0.76rem;
            width: 4.4rem;
            margin:0.35rem auto 0.34rem;
             img{
            width: 100%;
            height: 100%;
            }
         }  
        }
    }
</style>
